import React from "react";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import ChecklistRoundedIcon from "@mui/icons-material/ChecklistRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import FlagRoundedIcon from "@mui/icons-material/FlagRounded";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import LibraryBooksRoundedIcon from "@mui/icons-material/LibraryBooksRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import MapRoundedIcon from "@mui/icons-material/MapRounded";
import MemoryRoundedIcon from "@mui/icons-material/MemoryRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import RouteRoundedIcon from "@mui/icons-material/RouteRounded";
import SchemaRoundedIcon from "@mui/icons-material/SchemaRounded";
import StorageRoundedIcon from "@mui/icons-material/StorageRounded";
import WorkspacesRoundedIcon from "@mui/icons-material/WorkspacesRounded";

// Icons an admin can give an object type. The server accepts the same keys
// (ICONS in backend/services/viewConfig.js).
export const TYPE_ICONS = Object.freeze({
  object: CategoryRoundedIcon,
  map: MapRoundedIcon,
  domain: PublicRoundedIcon,
  cluster: WorkspacesRoundedIcon,
  scenario: RouteRoundedIcon,
  process: AccountTreeRoundedIcon,
  group: FolderRoundedIcon,
  library: LibraryBooksRoundedIcon,
  scopeItem: ChecklistRoundedIcon,
  diagram: SchemaRoundedIcon,
  document: DescriptionRoundedIcon,
  system: MemoryRoundedIcon,
  person: PersonRoundedIcon,
  data: StorageRoundedIcon,
  rule: GavelRoundedIcon,
  risk: ReportProblemRoundedIcon,
  goal: FlagRoundedIcon,
  link: LinkRoundedIcon,
});

// "scopeItem" reads as "Scope item".
export const iconLabel = (key) => {
  const words = String(key || "").replace(/([A-Z])/g, " $1").toLowerCase().trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

export default function TypeIcon({ name, ...props }) {
  const Icon = Object.prototype.hasOwnProperty.call(TYPE_ICONS, name) ? TYPE_ICONS[name] : CategoryRoundedIcon;
  return <Icon {...props} />;
}
